module.exports = __webpack_public_path__ + "static/media/noCartItems.015184ce.png";